import { Check } from "lucide-react";
import { memo } from "react";
import { useFormContext } from "react-hook-form";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@/common/components";
import { useAuth } from "@/common/hooks";

export const CustomerCard = memo(() => {
  const {
    auth: { isCargoOwner },
  } = useAuth();

  const form = useFormContext();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="mb-3 md:mb-4">
          {isCargoOwner ? "Информация о заказчике" : "Информация о собственнике вагона"}
        </CardTitle>

        <p className="flex gap-2 items-center text-Buttons-hover_1 text-sm font-normal leading-5 p-2 rounded-lg outline outline-1 outline-Buttons-main bg-Status-light_gray">
          <Check className="flex-shrink-0 w-4 h-4" /> Данные заполнены автоматически из профиля
          компании
        </p>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        <FormField
          control={form.control}
          name="customerName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {isCargoOwner
                  ? "Наименование КА (Заказчик)"
                  : "Наименование КА (Собственник вагона)"}
              </FormLabel>
              <FormControl>
                <Input {...field} disabled className="cursor-not-allowed" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="customerInn"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{isCargoOwner ? "ИНН (Заказчик)" : "ИНН (Собственник вагона)"}</FormLabel>
              <FormControl>
                <Input {...field} disabled className="cursor-not-allowed" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
});
